(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('timeRegisterGraph', {
        templateUrl: 'views/components/views/timeRegisterGraph/timeRegisterGraph.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$ihttp', function ($ihttp) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            
            let blogComments = [
                {
                    "blog": "My blog",
                    "day": "1",
                    "value": 3,
                    "userColor": "#ffd600"
                },
                {
                    "blog": "My blog",
                    "day": "2",
                    "value": 7,
                    "userColor": "#ffd600"
                },
                {
                    "blog": "My blog",
                    "day": "11",
                    "value": 14,
                    "userColor": "#ffd600"
                },
                {
                    "blog": "My blog",
                    "day": "12",
                    "value": 15,
                    "userColor": "#ffd600"
                },
                {
                    "blog": "My blog",
                    "day": "30",
                    "value": 6,
                    "userColor": "#ffd600"
                }
            ];

            vm.graphList = {
                item_id: '',
                item_name: '',
                item_graph: '',
                records: []
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALL

            async function loadGraphs() {
                $ihttp.post({
                    method: 86,
                    parameters: {}
                }).then((data) => {
                    //vm.graphList.item_graph = data;
                    //vm.graphList.records.length = 0;

                    //for (var i = 0; i < data.length; i++) {
                    //    vm.graphList.records.push(data[i]);
                    //}
                });
            }

            // #endregion LOAD PROCEDURE FUNCTION CALL

            // #region ON SERIES HOVER FUNCTION

            vm.onSeriesHover = function (e) {
                //console.log(kendo.format("event :: seriesHover ({0} : {1})", e.series.name, e.value));
                //console.dir(e);
            };

            // #endregion ON SERIES HOVER FUNCTION

            // #region K-DATA-SOURCE

            vm.imDataSource = new kendo.data.DataSource({
                data: blogComments
                //data: vm.graphList.item_graph
                //transport: {
                //    read: {
                //        url: "../content/dataviz/js/spain-electricity.json",
                //        dataType: "json"
                //    }
                //},
                //sort: {
                //    field: "year",
                //    dir: "asc"
                //}
            });

            // #endregion K-DATA-SOURCE

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadGraphs();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
